import React, { createContext, useContext, useState, ReactNode } from 'react';

interface LocationContextType {
  relatedCities: string[];
  setRelatedCities: (cities: string[]) => void;
  relatedProvinces: string[];
  setRelatedProvinces: (provinces: string[]) => void;
  allCities: string[];
  setAllCities: (cities: string[]) => void;
}

const LocationContext = createContext<LocationContextType | undefined>(undefined);

export const useLocationContext = () => {
  const context = useContext(LocationContext);
  if (context === undefined) {
    throw new Error('useLocationContext must be used within a LocationProvider');
  }
  return context;
};

interface LocationProviderProps {
  children: ReactNode;
}

export const LocationProvider: React.FC<LocationProviderProps> = ({ children }) => {
  const [relatedCities, setRelatedCities] = useState<string[]>([]);
  const [relatedProvinces, setRelatedProvinces] = useState<string[]>([]);
  const [allCities, setAllCities] = useState<string[]>([]);

  return (
    <LocationContext.Provider value={{
      relatedCities,
      setRelatedCities,
      relatedProvinces,
      setRelatedProvinces,
      allCities,
      setAllCities
    }}>
      {children}
    </LocationContext.Provider>
  );
};
